import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const StyledGoHomeButton = styled(Button)(({ theme }) => ({
  marginTop: '2rem',
  color: theme.palette.common.white
}));

export default StyledGoHomeButton;
